import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk'
import FloorIcon from '@material-ui/icons/Business'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import FavoriteIcon from '@material-ui/icons/Favorite'
import WavesIcon from '@material-ui/icons/Waves'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import GarminResource from './garminDashboard/GarminResource'

class GarminDashboard extends React.Component {
  state = { group: {} }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) this.setState({ group: data.data })
      else this.props.history.push('/groups')
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'steps', label: '走路', path: 'steps', icon: <DirectionsWalkIcon /> },
      { key: 'floors', label: '爬梯數', path: 'floors', icon: <FloorIcon /> },
      { key: 'distance', label: '距離', path: 'distance', icon: <LocationOnIcon /> },
      { key: 'heart', label: '平均心率', path: 'heart', icon: <FavoriteIcon /> },
      { key: 'stress', label: '壓力', path: 'stress', icon: <WavesIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid
    return (
      <AppShell
        uniqid={uniqid}
        title={`Garmin · ${this.state.group.name || ''}`}
        subtitle={this.state.group.description}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          <Route
            path={`${match.url}/steps`}
            render={() => (
              <GarminResource
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="steps"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/floors`}
            render={() => (
              <GarminResource
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="floorsclimbed"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/distance`}
            render={() => (
              <GarminResource
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="distanceinmeters"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/heart`}
            render={() => (
              <GarminResource
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="averageheartrateinbeatsperminute"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/stress`}
            render={() => (
              <GarminResource
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="averagestresslevel"
                uniqid={uniqid}
              />
            )}
          />
        </PageCard>
      </AppShell>
    )
  }
}

GarminDashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default GarminDashboard
